import { render } from "./CertificationMarks.vue?vue&type=template&id=156d1f32&scoped=true"
import script from "./CertificationMarks.vue?vue&type=script&lang=js"
export * from "./CertificationMarks.vue?vue&type=script&lang=js"

import "./CertificationMarks.vue?vue&type=style&index=0&id=156d1f32&scoped=true&lang=css"

import exportComponent from "C:\\bluespeed\\bluespeed\\frontend\\bluespeed\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156d1f32"]])

export default __exports__